import {
  Divider,
  Box,
  Paper,
  Stack,
  Typography,
  useTheme,
  LinearProgress,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Tooltip,
  Button,
} from "@mui/material";
import { Fragment, useEffect, useMemo, useState } from "react";
import UploadIcon from "@mui/icons-material/Upload";
import DownloadIcon from "@mui/icons-material/Download";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { convertBitsToBytes } from "../../../../utils/easyMaps/convertToBytes";
import StraightIcon from "@mui/icons-material/Straight";
import { useOutletContext } from "react-router-dom";
import { useMapa } from "../../../../contexts/mapaContext";
import useStyles from "./styles";
import { Timeline } from "@mui/icons-material";
import { set } from "lodash";

export default function Conexao(
  {
    conexao,
    index,
    expanded,
    setExpanded,
    unique,
    element,
    setOpenHistoryModal,
    setConnectionLocal,
  },
  key,
) {
  const { elements, connectionsDataMap } = useMapa();
  const theme = useTheme();
  const styles = useStyles({ theme });
  const [reference, setReference] = useState("");
  const [destination, setDestination] = useState("");
  const [capacidade, setCapacidade] = useState(0);
  const [percentInputTraffic, setPercentInputTraffic] = useState(0);
  const [percentOutputTraffic, setPercentOutputTraffic] = useState(0);
  const [percentMax, setPercentMax] = useState(0);
  const [corStatus, setCorStatus] = useState("");
  const [corStatusTx, setCorStatusTx] = useState("");
  const [corStatusRx, setCorStatusRx] = useState("");
  const connectionData = useMemo(
    () => connectionsDataMap?.get(conexao.id),
    [connectionsDataMap, conexao.id],
  );

  const convertInputTraffic = useMemo(
    () => convertBitsToBytes(connectionData?.rx_traffic || 0),
    [connectionData],
  );
  const convertOutputTraffic = useMemo(
    () => convertBitsToBytes(connectionData?.tx_traffic || 0),
    [connectionData],
  );

  useEffect(() => {
    if (!conexao || !elements) return;
    let reference = elements?.get(conexao.referenceId);
    if (reference) setReference(reference.titulo);
    let destination = elements?.get(conexao.destinationId);
    if (destination) setDestination(destination.titulo);
    // Define a capacidade do enlace
    // verifica se esta usando a capacidade do zabbix
    let flagCapacidadeAutomatica =
      conexao?.config?.flagCapacidadeAutomatica ?? false;

    let cap = flagCapacidadeAutomatica
      ? connectionData?.capacidade_zabbix / 1e9
      : (conexao?.config?.capacidade ?? 0);

    if (!cap || cap < 0 || cap == "" || !connectionData) {
      cap = 0;
      setPercentInputTraffic("- ");
      setPercentOutputTraffic("- ");
      setPercentMax("- ");
      setCorStatus(theme.palette.enlaces.offline.main);
      return;
    }
    setCapacidade(cap);
    const inputTrafficValue = connectionData?.rx_traffic
      ? parseFloat(connectionData?.rx_traffic) / 1e9
      : "- ";
    const outputTrafficValue = connectionData?.tx_traffic
      ? parseFloat(connectionData?.tx_traffic) / 1e9
      : "- ";
    let percentIn = isNaN(inputTrafficValue)
      ? 0
      : (inputTrafficValue / cap) * 100;
    let percentOut = isNaN(outputTrafficValue)
      ? 0
      : (outputTrafficValue / cap) * 100;
    setPercentInputTraffic(percentIn.toFixed(2));
    setPercentOutputTraffic(percentOut.toFixed(2));
    let percent = percentIn > percentOut ? percentIn : percentOut;
    setPercentMax(percent.toFixed(2));
    setCorStatus(connectionData?.corTraffic?.cor);
    setCorStatusTx(connectionData?.corTrafficTx?.cor);
    setCorStatusRx(connectionData?.corTrafficRx?.cor);
  }, [conexao.id, elements, connectionData]);

  function handleChange(selected) {
    setExpanded(selected == expanded ? null : selected);
  }

  return (
    <Accordion
      key={key}
      disableGutters
      expanded={expanded == conexao.id || unique}
      onChange={() => handleChange(conexao.id)}
      sx={{
        padding: "5px",
        borderRadius: "5px",
        backgroundColor: theme.palette.background.paperSelectedMaps,
        "&:hover": {
          backgroundColor: theme.palette.background.hover,
        },
        boxShadow: "none",
        border: "none",
        "&::before": {
          display: "none",
        },
      }}
    >
      <AccordionSummary
        expandIcon={!unique ? <ExpandMoreIcon /> : null}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
        sx={{
          padding: "0px",
        }}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          width="100%"
          ml={1}
        >
          <Box>
            <Box sx={[styles.line, { backgroundColor: corStatus }]}></Box>

            <Stack direction={"column"} gap={1} ml={1.5}>
              <>
                <Tooltip
                  title={
                    conexao?.referenceId === element?.id
                      ? reference
                      : destination
                  }
                >
                  <Typography sx={styles.text}>
                    {conexao?.referenceId === element?.id
                      ? reference
                      : destination}
                  </Typography>
                </Tooltip>
                <Divider width={"80px"} />

                <Tooltip
                  title={
                    conexao?.referenceId !== element?.id
                      ? reference
                      : destination
                  }
                >
                  <Typography sx={styles.text}>
                    {conexao?.referenceId !== element?.id
                      ? reference
                      : destination}
                  </Typography>
                </Tooltip>
              </>
            </Stack>
          </Box>
          <StraightIcon
            sx={{
              fontSize: "30px",
              transform:
                conexao?.referenceId == element?.id ? "rotate(180deg)" : null,
              mr: 0,
              color: theme.palette.mode == "dark" ? "#565656" : "#9A9A9A",
            }}
          />
        </Stack>
      </AccordionSummary>

      <AccordionDetails
        sx={{
          padding: "5px",
          display: "flex",
          gap: 1,
          flexDirection: "column",
        }}
      >
        <Tooltip title={conexao?.config?.interfaceDescription}>
          <Typography
            sx={{ ...styles.text, color: theme.palette.text.secondary }}
          >
            {conexao?.config?.interfaceDescription}
          </Typography>
        </Tooltip>
        {connectionData?.interface != null ? (
          <>
            <Paper
              sx={[
                styles.detailsCard,
                {
                  backgroundColor: theme.palette.background.paperLinkedMaps,
                },
              ]}
              elevation={0}
            >
              <Stack direction={"column"} gap={2}>
                <Typography textAlign={"center"} sx={styles.textAlerta}>
                  {"Tráfego da Interface " + connectionData?.interface}
                </Typography>
                <Stack direction={"row"} justifyContent={"space-around"}>
                  <Stack alignItems={"center"}>
                    <Stack direction={"row"} sx={{ alignItems: "flex-end" }}>
                      <Typography sx={styles.textLarge}>
                        {capacidade}
                      </Typography>
                      <Typography color="primary.main" mb={"6px"}>
                        Gbps
                      </Typography>
                    </Stack>
                    <Typography sx={styles.textMedium}>Capacidade</Typography>
                  </Stack>
                  <Stack alignItems={"center"}>
                    <Stack direction={"row"} sx={{ alignItems: "flex-end" }}>
                      <Typography sx={styles.textLarge}>
                        {percentMax}
                      </Typography>
                      <Typography color="primary.main" mb={"6px"}>
                        %
                      </Typography>
                    </Stack>{" "}
                    <Typography sx={styles.textMedium}>Em uso</Typography>
                  </Stack>
                </Stack>
                <Divider variant="middle" />
                <Stack direction={"column"} sx={{ padding: "5px" }}>
                  <Stack direction={"row"} alignItems={"center"} gap={1}>
                    <DownloadIcon
                      sx={[styles.textMedium, { fontSize: "20px" }]}
                    />
                    <Typography sx={styles.textMedium}>Entrada (RX)</Typography>
                  </Stack>
                  <Stack
                    mt={1}
                    direction={"row"}
                    justifyContent={"space-between"}
                  >
                    <Stack direction={"row"} gap={"5px"}>
                      <Typography>{convertInputTraffic.valor}</Typography>
                      <Typography
                        color="primary.main"
                        variant="small"
                        mt={"4px"}
                      >
                        {convertInputTraffic.unidade}
                      </Typography>
                    </Stack>
                    <Stack direction={"row"} gap={"5px"}>
                      <Typography>{percentInputTraffic}</Typography>
                      <Typography
                        color="primary.main"
                        variant="small"
                        mt={"4px"}
                      >
                        {"%"}
                      </Typography>
                    </Stack>
                  </Stack>
                  <LinearProgress
                    variant="determinate"
                    sx={{
                      backgroundColor: "#4e4e4e6b",
                      "& .MuiLinearProgress-bar": {
                        backgroundColor: corStatusRx,
                      },
                    }}
                    value={
                      percentInputTraffic > 100
                        ? 100
                        : parseFloat(percentInputTraffic)
                    }
                    width="100%"
                  />
                </Stack>{" "}
                <Stack direction={"column"} sx={{ padding: "5px" }}>
                  <Stack direction={"row"} alignItems={"center"} gap={1}>
                    <UploadIcon
                      sx={[styles.textMedium, { fontSize: "20px" }]}
                    />
                    <Typography sx={styles.textMedium}>Saída (TX)</Typography>
                  </Stack>

                  <Stack
                    mt={1}
                    direction={"row"}
                    justifyContent={"space-between"}
                  >
                    <Stack direction={"row"} gap={"5px"}>
                      <Typography>{convertOutputTraffic.valor}</Typography>
                      <Typography
                        color="primary.main"
                        variant="small"
                        mt={"4px"}
                      >
                        {convertOutputTraffic.unidade}
                      </Typography>
                    </Stack>
                    <Stack direction={"row"} gap={"5px"}>
                      <Typography>{percentOutputTraffic}</Typography>
                      <Typography
                        color="primary.main"
                        variant="small"
                        mt={"4px"}
                      >
                        {"%"}
                      </Typography>
                    </Stack>
                  </Stack>
                  <LinearProgress
                    variant="determinate"
                    sx={{
                      backgroundColor: "#4e4e4e6b",
                      "& .MuiLinearProgress-bar": {
                        backgroundColor: corStatusTx,
                      },
                    }}
                    value={
                      percentOutputTraffic > 100
                        ? 100
                        : parseFloat(percentOutputTraffic)
                    }
                    width="100%"
                  />
                </Stack>{" "}
              </Stack>{" "}
            </Paper>
          </>
        ) : (
          <Typography sx={[styles.textAlerta, { textAlign: "center" }]}>
            {" "}
            Não há dados disponíveis no momento
          </Typography>
        )}
        {
          <Button
            variant="contained"
            sx={{
              backgroundColor: theme.palette.background.default,
              color: theme.palette.text.primary,
              textTransform: "capitalize",
              height: 48,
            }}
            disableElevation
            onClick={() => {
              setOpenHistoryModal(true);
              setConnectionLocal(conexao);
            }}
            startIcon={<Timeline />}
          >
            Ver histórico
          </Button>
        }
        {connectionData?.itensData?.length != 0 && (
          <Accordion
            key={key + "outrosItens"}
            disableGutters
            sx={{
              backgroundColor: theme.palette.background.paperLinkedMaps,
              boxShadow: "none",
              "&::before": {
                display: "none",
              },
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1bh-content"
              id="panel1bh-header"
            >
              <Typography sx={styles.textHeaderAco}>Outros itens</Typography>
            </AccordionSummary>
            <AccordionDetails>
              {connectionData?.itensData?.map((item, index) => (
                <Fragment key={index + item.name}>
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent={"space-between"}
                    width="100%"
                  >
                    <Typography
                      sx={styles.textAlerta}
                      fontSize={"0.7rem"}
                      width="170px"
                    >
                      {item.name}
                    </Typography>

                    <Stack direction={"row"} gap={"2px"}>
                      <Typography textAlign={"end"}>
                        {item?.lastvalue}
                      </Typography>

                      <Typography color="primary" variant="small" mt={"5px"}>
                        {item?.units}
                      </Typography>
                    </Stack>
                  </Stack>
                  <Divider sx={{ mt: 1, mb: 1 }} />
                </Fragment>
              ))}
            </AccordionDetails>
          </Accordion>
        )}
      </AccordionDetails>
    </Accordion>
  );
}
